"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerStatus = void 0;
var PlayerStatus;
(function (PlayerStatus) {
    PlayerStatus["Playing"] = "playing";
    PlayerStatus["Stopped"] = "stopped";
})(PlayerStatus || (exports.PlayerStatus = PlayerStatus = {}));
